// tslint:disable
import { Component, Injector } from "@angular/core";

import { CMFormComponent } from "../../@cmcore/component/cmform/cmform.component";

import {
  CMFormGlobaisComponent,
  CMFormModalComponent,
  CMGridEditConfig,
  CMInputConfig,
  CMGridEditConfigColumn,
  CMGridEditConfigMore,
} from "../../@cmcore/component";
import {
    OrdemCompraBrowseComponent,
} from "../index";
@Component({
  selector: "ordem-compra-relatorios",
  templateUrl: "ordem-compra-relatorios.component.html",
  styleUrls: ["ordem-compra-relatorios.component.scss"],
})
export class OrdemCompraRelatoriosComponent extends CMFormComponent {
  _owner: OrdemCompraBrowseComponent = undefined;

  get owner() {
    return this._owner;
  }

  private static relatoriosCustomizados: any = [];

  static addRelatorioCustomizado(item: any){
    OrdemCompraRelatoriosComponent.relatoriosCustomizados.push(item);
  }

  static getRelatorioCustomizados(){
    return OrdemCompraRelatoriosComponent.relatoriosCustomizados;
  }

  teste = 0;

  dados = {
    tiporelatorio: "OrdemCompraPadrao",
  };

  config = {
    tiporelatorio: new CMInputConfig({
                                    form: this,
                                    values: [
                                      {value: "OrdemCompraPadrao", text: "Ordem de Compra Padrão"},
                                    ],
                                  }),
  };

  Imprimir(){
    
    if (this.dados.tiporelatorio === "OrdemCompraPadrao"){
        let data = { id: this.owner.grid.fieldByName(this.owner.fieldNameId()) };
        console.log(data);
        data = this.owner.getDataPrint(data);
        this.showRelat(
          "/Print",
          data,
          "ordemcompra"
        );
    }
    else{
      let data = { 
        id: this.owner.grid.fieldByName(this.owner.fieldNameId()),
        idrelatorio: this.dados.tiporelatorio
      };
      console.log(data);
      data = this.owner.getDataPrint(data);
      this.showRelat(
        "/ImpressaoOrdemCompraCustomizado",
        data,
        "ordemcompra"
      );
      
    }
  }

  podeCadastrarProduto: boolean = false;
  set owner(value) {
    this._owner = value;
  }

  constructor(_injector: Injector) {
    super(_injector);
    console.log('construtor');
    this.config.tiporelatorio.values.push.apply(this.config.tiporelatorio.values, OrdemCompraRelatoriosComponent.relatoriosCustomizados)
  }


  close(formName) {
    if (this.owner) this.owner.beforeComponent = undefined;
    CMFormModalComponent.close(formName);
  }
}
